import classNames from "classnames";

export const ActivityDetailField: React.FC<{
  label: string | JSX.Element;
  value: string | JSX.Element;
  key?: string;
  className?: string;
  separator?: boolean;
}> = ({ label, value, key, className, separator = false }) => {
  return (
    <div
      className={classNames(className, "flex flex-col overflow-hidden")}
      key={key}
    >
      <div className="flex flex-row items-center justify-between">
        <span className="text-lg font-semibold text-[--milkylb-color-neutral-400]">
          {label}
        </span>
        <span className="text-wrap text-lg text-[--milkylb-color-neutral-400]">
          {value}
        </span>
      </div>
      {separator && (
        <div className="mt-2 border-b border-[--milkylb-color-neutral-400]" />
      )}
    </div>
  );
};
